import SingleSelectFilter from './SingleSelectFilter';
import { Hours } from '@customer/store/types';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { ReactElement, Ref, useCallback, useMemo } from 'react';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { FiltersState } from '@customer/store/slices/filtersSlice';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { DateTime } from 'luxon';

const useTimeOfDayOptions = (): DropdownItemProps<Hours>[] => {
  const { showHourOnly } = useLocaleFormatter();

  const getHourOfDay = useCallback(
    (hour: string) => {
      const num = Number(hour);
      const timeOfDay = DateTime.now().startOf('day').plus({ hours: num });
      return showHourOnly(timeOfDay);
    },
    [showHourOnly],
  );

  return useMemo(() => {
    return Object.values(Hours).map((value: Hours) => {
      return {
        key: value,
        value,
        stringValue: value,
        label: getHourOfDay(value),
      };
    });
  }, [getHourOfDay]);
};

interface TimeOfDayFilterProps {
  filterName: keyof Pick<FiltersState, 'timeOfDayStart' | 'timeOfDayEnd'>;
  label: ReactElement | string;
  elementRef: Ref<HTMLVdsBasicDropdownElement>;
  action: ActionCreatorWithPayload<Hours>;
}

export const TimeOfDayFilter = ({
  filterName,
  label,
  elementRef,
  action,
}: TimeOfDayFilterProps) => {
  return (
    <SingleSelectFilter<Hours>
      filterName={filterName}
      label={label}
      elementRef={elementRef}
      action={action}
      useItemsHook={useTimeOfDayOptions}
    />
  );
};

export default TimeOfDayFilter;
